import React from 'react';

const OutcomeStats = () => {
  return (
    <div className="font-sans">
      
      {/* Benefits Section */}
      <section className="bg-cogBrand py-10 sm:py-14 lg:py-16 text-white border-y border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-xl text-2xl sm:text-3xl lg:text-4xl font-bold mb-8 sm:mb-10 text-center md:text-left tracking-tight">
            The Value of Our Engineering-Led Process
          </h3>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-x-6 gap-y-8 sm:gap-x-8 text-center md:text-left">
            
            <div className="flex flex-col items-center md:items-start pb-6 sm:pb-0 border-b border-white/10 sm:border-b-0 last:border-b-0">
              <div className="text-lg sm:text-xl font-medium text-cogCyan mb-2 leading-snug">
                Design Optimization
              </div>
              <div className="text-xs sm:text-sm font-normal text-white/70 leading-relaxed max-w-[220px] md:max-w-none">
                Manufacturing feasibility is validated at the design stage, prior to production release.
              </div>
            </div>
            
            <div className="flex flex-col items-center md:items-start pb-6 sm:pb-0 border-b border-white/10 sm:border-b-0">
              <div className="text-lg sm:text-xl font-medium text-cogCyan mb-2 leading-snug">
                Reduced Development Time
              </div>
              <div className="text-xs sm:text-sm font-normal text-white/70 leading-relaxed max-w-[220px] md:max-w-none">
                3D routing and DMU validation are completed upfront to shorten development cycles.
              </div>
            </div>
            
            <div className="flex flex-col items-center md:items-start pb-6 sm:pb-0 border-b border-white/10 sm:border-b-0">
              <div className="text-lg sm:text-xl font-medium text-cogCyan mb-2 leading-snug">
                Improved Manufacturability
              </div>
              <div className="text-xs sm:text-sm font-normal text-white/70 leading-relaxed max-w-[220px] md:max-w-none">
                Designs are refined for efficient, repeatable production at scale.
              </div>
            </div>
            
            <div className="flex flex-col items-center md:items-start pb-6 sm:pb-0 border-b border-white/10 sm:border-b-0">
              <div className="text-lg sm:text-xl font-medium text-cogCyan mb-2 leading-snug">
                Reliable Performance
              </div>
              <div className="text-xs sm:text-sm font-normal text-white/70 leading-relaxed max-w-[220px] md:max-w-none">
                Each harness undergoes continuity and crimp-strength testing prior to dispatch.
              </div>
            </div>
            
            <div className="flex flex-col items-center md:items-start pb-6 sm:pb-0 border-b border-white/10 sm:border-b-0">
              <div className="text-lg sm:text-xl font-medium text-cogCyan mb-2 leading-snug">
                Consistent Quality
              </div>
              <div className="text-xs sm:text-sm font-normal text-white/70 leading-relaxed max-w-[220px] md:max-w-none">
                Backed by a management system certified to ISO 9001:2015.
              </div>
            </div>

            <div className="flex flex-col items-center md:items-start">
              <div className="text-lg sm:text-xl font-medium text-cogCyan mb-2 leading-snug">
                End-to-End Support
              </div>
              <div className="text-xs sm:text-sm font-normal text-white/70 leading-relaxed max-w-[220px] md:max-w-none">
                A single point of accountability from engineering design through final dispatch.
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Image Callout Section (parallax on larger screens only, static on mobile) */}
      <section 
        className="relative min-h-[320px] sm:min-h-[420px] lg:min-h-[500px] flex items-center overflow-hidden bg-scroll md:bg-fixed bg-cover bg-center"
        style={{ 
          backgroundImage: `linear-gradient(rgba(10, 17, 40, 0.45), rgba(10, 17, 40, 0.45)), url('https://img.magnific.com/free-photo/future-visions-business-technology-concept_23-2151893447.jpg?semt=ais_hybrid&w=740&q=80')` 
        }}
        aria-label="Wiring harness manufacturing facility background"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10 py-10 sm:py-12">
          <div className="max-w-md sm:max-w-lg bg-cogBrand/80 backdrop-blur-sm p-5 sm:p-7 lg:p-8 border-l-4 border-cogCyan">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-4 sm:mb-6 tracking-tight leading-tight">
              An Engineering-Led Approach to Harness Manufacturing
            </h2>
            
            <p className="text-sm sm:text-base text-white/80 leading-relaxed">
              From schematic design and 3D validation to precision assembly and ISO 9001:2015-certified
              quality control, each harness is engineered, manufactured, and verified within a single,
              accountable facility.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default OutcomeStats;